import { createSlice } from "@reduxjs/toolkit";
import { sum } from 'lodash';
import { baseApi } from "../../../app/baseApi";
import { apiTags } from "../../../app/store/apiTags";

const basePath = 'activityinvoice';

export const activityInvoiceApi = baseApi.injectEndpoints({
    reducerPath: 'loadInvoiceApi',
    endpoints: (builder) => ({
        getActivityInvoices: builder.query({
            query: (body) => ({
                url: `${basePath}?${Object.keys(body)?.filter(k => body[k]).map(k => `${k}=${body[k]}`)?.join('&')}`,

            }),
            providesTags: [apiTags.ACTIVITY_INVOICES],
            transformResponse: (response) => {
                return response.map(invoice => ({
                    ...invoice,
                }));
            }
        }),
        updateActivityInvoiceDetails: builder.mutation({
            query: (body) => ({
                url: `${basePath}/details`,
                method: "PUT",
                body
            }),
            invalidatesTags: [apiTags.ACTIVITY_INVOICES],
        }),
        updateActivityInvoiceTotals: builder.mutation({
            query: (body) => ({
                url: `${basePath}/totals`,
                method: "PUT",
                body
            }),
            invalidatesTags: [apiTags.ACTIVITY_INVOICES],
        }),
        reprocessActivityInvoice: builder.mutation({
            query: (body) => ({
                url: `${basePath}/reprocess`,
                method: "POST",
                body,
                cache: "no-cache"
            }),
            invalidatesTags: [apiTags.ACTIVITY_INVOICES],
        }),
        getActivityReports: builder.mutation({
            query: reports => ({
                url: `${basePath}/Report`,
                method: "POST",
                body: reports,
                responseHandler: async (response) => {
                    response.blob().then(blob => {
                        // Creating new object of PDF file
                        const fileURL = window.URL.createObjectURL(blob);
                        // Setting various property values
                        let alink = document.createElement('a');
                        alink.href = fileURL;
                        alink.download = 'Activity Reports.zip';
                        alink.click();
                    })
                    //window.location.assign(window.URL.createObjectURL(await response.blob())) 
                },
                cache: "no-cache"
            })
        }),
        approveActivityInvoice: builder.mutation({
            query: (body) => ({
                url: `${basePath}/approve`,
                method: "POST",
                body
            }),
            invalidatesTags: [apiTags.ACTIVITY_INVOICES],
        }),
        sendActivityInvoiceToQB: builder.mutation({
            query: (body) => ({
                url: `${basePath}/sendToQB`,
                method: "POST",
                body
            }),
            invalidatesTags: [apiTags.ACTIVITY_INVOICES],
        }),
    })

});


export const {
    useGetActivityInvoicesQuery,
    useUpdateActivityInvoiceDetailsMutation,
    useUpdateActivityInvoiceTotalsMutation,
    useReprocessActivityInvoiceMutation,
    useGetActivityReportsMutation,
    useApproveActivityInvoiceMutation,
    useSendActivityInvoiceToQBMutation,
} = activityInvoiceApi;

export const activityInvoiceStateSlice = createSlice({
    name: 'activityInvoiceStateSlice',
    initialState: {
        searchVal: '',
        filters: {
            'clientId': '',
            'clientAccountId': '',
            'month': '',
            'year': ''
        }
    },
    reducers: {
        setSearchVal: (state, action) => {
            state.searchVal = action.payload;
        },
        setFilters: (state, action) => {
            state.filters = action.payload;
        },
        setFilter: (state, action) => {
            state.filters = { ...state.filters, [action.payload.key]: action.payload.value }
        },
    },
});

export const { setSearchVal,
    setFilters, 
    setFilter } = 
    activityInvoiceStateSlice.actions;
